import React from "react";

export default function RadioGroup({
  name,
  options = [],
  selectedValue,
  onChange,
  isDisabled,
}) {
  const handleChange = (value) => {
    if (typeof onChange === "function") onChange(value);
  };

  return (
    <div className="checkbox-container">
      {options.map((opt, idx) => {
        const id = `${name}_${String(opt.value)}`;
        return (
          <div className="checkbox-item" key={`${id}_${idx}`}>
            <div className="checkbox-representation">
              <input
                type="radio"
                name={name}
                id={id}
                value={opt.value}
                checked={selectedValue === opt.value}
                onChange={() => handleChange(opt.value)}
                disabled={isDisabled}
              />
              <label htmlFor={id}>{opt.label}</label>
            </div>
          </div>
        );
      })}
    </div>
  );
}
